define('app-ConciergeTP/settings',[],function () {
    return {
        container: $('#conciergeContent'),
        upgradeCheckbox: '#RequestCabinUpgrade',
        upgradeContentContainer: '#upgradeContentContainer',
        giftContentContainer : '#giftContentContainer',
        giftcheckbox : '#isGift',
        giftMessage : '#GiftMessage',
        tableSizeContainer: '#tableSizeContainer',
        fixedDiningInput: '#FixedDining',
        tableSizeValidationMessage: '#tableSizeValidationMessage',
        tableSizeInput: '#tableSize',
        shoppingItemContainer: '#shoppingItemContainer',
        runningtotal: '#runningTotal',
        diningOptions : '#diningOptions .dining-option',       
        diningOptionsContainer: '#diningOptions',
        contactContainer: '#contactContainer',
        contactOptionInputs: '.contact-option',
        contactValidationMessagesContainer: '#contactValidationMessagesContainer',
        contactValueValidationMessages: '.contact-value-validation-message',
        selectGiftItemsValidationMessage: '#selectGiftItemsValidationMessage',
        shoppingQuantityInputs: '.shopping-quantity-input',
        selectContactMethodValidationMessage: '#selectContactMethodValidationMessage',
        isOceanCruise: '#IsSagaOceanCruise',
        tabs: '.app-Concierge-Tabs',
        tab: '.tab',
        tabLink: '.tabLink',
        submit: $('#conciergeContainer input[type=submit]')
    };
});
